import axios from 'axios';
import Page from '../../lib/page';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default function updateBnaData(articleInfo) {
  if (Page.isLoggedIn()) {
    const {
      bnaListId = '',
      bnaId = '',
      intentId = '',
      intentPromptedTime = '',
    } = articleInfo.channelDetails || {};
    if (bnaListId && bnaId && intentId && intentPromptedTime) {
      return axios.post('/smarthelp/update-bna-data', {
        _csrf: Page.getCSRFtoken(),
        bnaListId,
        bnaId,
        intentId,
        intentPromptedTime,
      })
        .then(() => {})
        .catch(() => {}); // Catch BNA error for solving unhandle promise reject issue
    }
  }
  return undefined;
}
// }
